/**
 * Dashboard Router Component
 * Routes users to appropriate dashboard based on their role
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

const DashboardRouter: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();

  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }

    // Check if user is admin (roleLevel -1)
    const isAdmin = user.roleLevel === -1;

    if (isAdmin) {
      // Redirect admin users to admin dashboard
      navigate('/admin', { replace: true });
    } else {
      // Redirect manufacturer users to manufacturer dashboard
      navigate('/manufacturer', { replace: true });
    }
  }, [user, navigate]);

  // Show loading while redirecting
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Loading dashboard...</p>
      </div>
    </div>
  );
};

export default DashboardRouter;
